export const TAGS = {
  AVAILABLE_PAYMENT_METHODS: "AvailablePaymentMethods",
  CART_ID: "CartId",
  CART_ITEMS: "CartItems",
  CART_ORDER_PRICES: "CartOrderPrices",
  COUNTRY: "Country",
  COUPONS: "Coupons",
  ORDER: "Order",
  ORDERS: "Orders",
  ORDER_ATTRIBUTES: "OrderAttributes",
  ORDER_DELIVERY_LIMITS: "OrderDeliveryLimits",
  SHIPPING_METHODS: "ShippingMethods",
  STORE_CONFIG: "StoreConfig",
  CUSTOMER_ORDERS_ALL_STORES: "CustomerOrdersAllStores",
};
